import { render, staticRenderFns } from "./couponListComponent.vue?vue&type=template&id=13a61740"
import script from "./couponListComponent.vue?vue&type=script&lang=js"
export * from "./couponListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports